import longboardingAmenitiesPage from 'src/helpers/flows/pages/default/longboardingAmenitiesPage';
import longboardingAnythingElsePage from 'src/helpers/flows/pages/default/longboardingAnythingElsePage';
import longboardingBackyardFeaturesPage from 'src/helpers/flows/pages/default/longboardingBackyardFeaturesPage';
import longboardingBathroomFeaturesPage from 'src/helpers/flows/pages/default/longboardingBathroomFeaturesPage';
import longboardingFlooringPage from 'src/helpers/flows/pages/default/longboardingFlooringPage';
import longboardingHomeFeaturesPage from 'src/helpers/flows/pages/default/longboardingHomeFeaturesPage';
import longboardingHomeLayoutPage from 'src/helpers/flows/pages/default/longboardingHomeLayoutPage';
import longboardingHomeSystemsPage from 'src/helpers/flows/pages/default/longboardingHomeSystemsPage';
import longboardingKitchenFeaturesPage from 'src/helpers/flows/pages/default/longboardingKitchenFeaturesPage';

export const longboardingPageSet = [
  longboardingFlooringPage,
  longboardingKitchenFeaturesPage,
  longboardingHomeLayoutPage,
  longboardingBathroomFeaturesPage,
  longboardingHomeFeaturesPage,
  longboardingBackyardFeaturesPage,
  longboardingAmenitiesPage,
  longboardingHomeSystemsPage,
  longboardingAnythingElsePage,
];
